import { render, staticRenderFns } from "./voucherVisualizado.vue?vue&type=template&id=072d2dfe"
import script from "./voucherVisualizado.vue?vue&type=script&lang=js"
export * from "./voucherVisualizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports